import React, {useMemo, useState} from 'react';
import { useTranslation } from 'react-i18next';
import {Modal, ModalBody, ModalFooter, ModalHeader} from "../Modal";
import CustomButton from "../CustomButton";
import { getLanguage } from "../../lang/helpers";
import ModelB from './components/ModelB';
import ModelC from './components/ModelC';
import ModelD from './components/ModelD';
import ModelE from './components/ModelE';
import ModelA from './components/ModelA';
import { getSteps, StepType } from './Steps';

interface Props {
  hasCoach: boolean;
  hasAssessment: boolean;
  close: Function;
}

const stepComponents: Record<StepType, React.ComponentType<any>> = {
  A: ModelA,
  B: ModelB,
  C: ModelC,
  D1: ModelD,
  D2: ModelD,
  E: ModelE,
};

const Infographic = (props: Props) => {
  const { t, i18n } = useTranslation();
  // Fallback to 'en' if language is not recognized or is not 'sv'.
  const lang = getLanguage(i18n.language);


  const steps = useMemo(() => getSteps(props.hasAssessment, props.hasCoach), [props.hasAssessment, props.hasCoach]);
  // step arrya is contasing thye steps
  // As Step is the array we can find the current step, number of steps and the total steps
  // StepComponet is the dereactory of steps
  const [currentStepIndex, setCurrentStepIndex] = useState(0);
  const currentStep = steps[currentStepIndex];
  const StepComponent = stepComponents[currentStep];

  const handleNext = () => {
    if (currentStepIndex < steps.length - 1) {
      setCurrentStepIndex((prev) => prev + 1);
    } else {
      props.close();
    }
  };

  // My logic to determine steps based on hasCoach and hasAssessment
  // if(props.hasCoach && props.hasAssessment) {
  //   steps = ["A", "B", "C","D1","E"];
  // } else if(!props.hasCoach && !props.hasAssessment) {
  //   steps = ["C","D2","E"];
  // } else if(props.hasCoach && !props.hasAssessment) {
  //   steps = ["A", "c", "D1","E"];
  // } else if(!props.hasCoach && props.hasAssessment) {
  //   steps = ["B", "C","D2","E"];
  // } else {
  //   steps = [];
  // }

  return (
    // Model close only when the user clicks on the next button and when the user is on the last step.Outside click should not close the model
    <Modal isOpen={true}>
      <ModalHeader>
        {t("tutorial-header")} {steps.length} {t("tutorial-header-steps")}
      </ModalHeader>
      <ModalBody >
          <StepComponent variant={currentStep} currentStepNumber={currentStepIndex + 1}
            totalSteps={steps.length} />
      </ModalBody>
      <ModalFooter>
        <CustomButton onClick={handleNext} buttonType="blueBase"> {currentStepIndex === steps.length - 1 ? t("getstart") : t("next")}</CustomButton>
      </ModalFooter>
    </Modal>
  );
};

export default Infographic;
